<template>
  <div class="pagination-wrap">
    <a-pagination
      :total="total"
      :defaultPageSize="10"
      :defaultCurrent="1"
      @change="onChange"
    />
  </div>
</template>

<script>
import api from "@/api";
export default {
  mounted() {
    this.getTagCount();
    this.init();
  },
  data() {
    return {
      total: null,
    };
  },
  methods: {
    async init() {
      await this.listenForGetTotal();
    },
    async getTagCount() {
      try {
        const res = await api.countTags();
        console.log(res.data.res);
        this.total = res.data.res;
      } catch (error) {
        console.log(error);
      }
    },
    async listenForGetTotal() {
      this.EventBus.$on("getTotal", () => {
        this.getTagCount();
      });
    },
    onChange(page, pageSize) {
      this.EventBus.$emit("handlePagination", {
        page,
        pageSize,
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.pagination-wrap {
  margin: 25px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

<style>

</style>